import React from "react";
import "./SignIn.css";
import { GoogleLogin } from "@react-oauth/google";
import { Button, Modal, Form, Alert } from "react-bootstrap";
import { Form as ReactFinalForm, Field } from "react-final-form";
import { isEmail, isMobilePhone, isAlphanumeric } from "validator";
import { connect } from "react-redux";
import {
  registerUser,
  loginUser,
  googleLogin,
} from "../../actions/userActions";
import { Redirect } from "react-router-dom";
import {
  openSignUpModal,
  closeSignUpModal,
} from "../../actions/generalActions";
import history from "../../config/history";
import { pageview } from "../../utils/googleAnalyticsUtils";

class SignIn extends React.Component {

  componentDidMount(){
    pageview('Sign In');
  }

  componentWillUnmount() {
    this.props.closeSignUpModal();
  }

  state = { signUp: false };
  toggleSignUp = () => {
    this.setState((prevState) => ({
      signUp: !prevState.signUp,
    }));
  };
  onSubmit = async (values) => {
    if (this.state.signUp) await this.props.registerUser(values);
    else await this.props.loginUser(values);
  };
  required = (v) => (v ? undefined : "Required");
  maxLength = (max) => (v) =>
    v && v.length > max ? `Must be ${max} characters or less` : undefined;
  minLength = (min) => (v) =>
    v && v.length < min ? `Must be ${min} characters or more` : undefined;
  phone = (v) =>
    v && isMobilePhone(v.toString()) ? undefined : "Invalid Phone Number";
  email = (v) =>
    v && isEmail(v.toString()) ? undefined : "Invalid Email Address";
  alphaNum = (v) =>
    v && isAlphanumeric(v.toString())
      ? undefined
      : "Must contain only 'A-Z' or '0-9'";
  checkConfirmPassword = (v, values) =>
    v && v == values.password ? undefined : "The passwords do not match";

  composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  handleGoogleLogin = (googleData) => {
    this.props.googleLogin(googleData.credential);
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showSignupModal}
          onHide={this.props.closeSignUpModal}
          animation={true}
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div>
              {/* React Final Form starts */}
              <ReactFinalForm
                onSubmit={this.onSubmit}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                }) => {
                  return (
                    <form className="form-signin" onSubmit={handleSubmit}>
                      <div className="signin-logo-container">
                        <img
                          width="200"
                          height="83"
                          className="signin-logo"
                          src={`${process.env.REACT_APP_AWS_IMG_CDN}/logos/Main_logo_200_ 83.webp`}
                          alt="Colourful Logo with the colours red, yellow, orange, peach, purple, blue and brown. The Logo reads “MeenduToons” and has small ice cream scoops and waffles decorated over it"
                        />
                      </div>
                      <h1 className="h3 mb-3 font-weight-normal">
                        Sign {!this.state.signUp ? "in" : "up"}
                      </h1>
                      {/* Handle Errors recieved from backend */}
                      {this.props.error && (
                        <Alert variant="danger">
                          <p>{this.props.error}</p>
                        </Alert>
                      )}
                      <Field
                        name="email"
                        validate={this.composeValidators(
                          this.required,
                          this.email,
                          this.minLength(1),
                          this.maxLength(255)
                        )}
                      >
                        {({ input, meta }) => (
                          <div>
                            <Form.Group>
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                {...input}
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                isInvalid={meta.touched && meta.error}
                                autofocus
                              />

                              <Form.Control.Feedback type="invalid">
                                {meta.error}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        )}
                      </Field>
                      {!this.state.signUp ? null : (
                        <Field
                          name="name"
                          validate={this.composeValidators(
                            this.required,
                            this.minLength(1),
                            this.maxLength(50)
                          )}
                        >
                          {({ input, meta }) => (
                            <div>
                              <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                  {...input}
                                  type="text"
                                  placeholder="Name"
                                  isInvalid={meta.touched && meta.error}
                                />

                                <Form.Control.Feedback type="invalid">
                                  {meta.error}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          )}
                        </Field>
                      )}

                      <Field
                        name="password"
                        validate={this.composeValidators(
                          this.required,
                          this.minLength(8),
                          this.maxLength(50)
                        )}
                      >
                        {({ input, meta }) => (
                          <div>
                            <Form.Group>
                              <Form.Label>Password</Form.Label>
                              <Form.Control
                                {...input}
                                type="password"
                                placeholder="Password"
                                isInvalid={meta.touched && meta.error}
                              />

                              <Form.Control.Feedback type="invalid">
                                {meta.error}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        )}
                      </Field>
                      {!this.state.signUp ? null : (
                        <Field
                          name="confirmPassword"
                          validate={this.checkConfirmPassword}
                        >
                          {({ input, meta }) => (
                            <div>
                              <Form.Group>
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control
                                  {...input}
                                  type="password"
                                  placeholder="Confirm Password"
                                  isInvalid={meta.touched && meta.error}
                                />

                                <Form.Control.Feedback type="invalid">
                                  {meta.error}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </div>
                          )}
                        </Field>
                      )}
                      <button
                        className="ds-btn-primary w-100"
                        variant=""
                        type="submit"
                        style={{ marginTop: "10px" }}
                      >
                        Sign {!this.state.signUp ? "in" : "up"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-link w-100"
                        onClick={this.toggleSignUp}
                      >
                        {!this.state.signUp
                          ? "New to MeenduToons? Join now!"
                          : "Already have an account? click here"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-link w-100"
                        onClick={() => history.push("/users/pwdReset")}
                      >
                        {!this.state.signUp && "Forgot Password"}
                      </button>
                      <div className="google-login-button">
                        <GoogleLogin
                          className="w-100 "
                          onSuccess={this.handleGoogleLogin}
                          onError={() => console.log("google oauth failed")}
                        />
                      </div>
                    </form>
                  );
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.userLogin.userInfo,
    loading: state.userLogin.loading,
    error: state.userLogin.error,
    showSignupModal: state.general.showSignupModal,
  };
};
export default connect(mapStateToProps, {
  registerUser,
  loginUser,
  googleLogin,
  openSignUpModal,
  closeSignUpModal,
})(SignIn);
